import React from "react";
import { useSignFormStore } from "src/stores/SignFormStore";
import styled from "styled-components";

const Container = styled.input<{ $isValid?: boolean }>`
  border-radius : 5px;
  border : 1px solid ${({ $isValid }) => ($isValid ? "#ccc" : "#FF5A5A")};
  font-size: 16px;
  width: 100%;
  display: block;
  flex-grow: 1;
  padding: 10px 20px;
  box-sizing: border-box;
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex-grow: 1;
`

interface Props {
  type? :string;
  defaultValue?: string; 
  placeholder?: string;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  state? : React.Dispatch<React.SetStateAction<boolean>> 
  isValid? : boolean
}

const InputBox = ({ placeholder, defaultValue, type, onBlur, state, isValid }: Props) => {
  // ✅ Zustand 상태를 최적화하여 한 번만 가져옴
  const handleBlur = async (e: React.FocusEvent<HTMLInputElement>) => {
    await onBlur(e); // ✅ 부모 `onBlur` 실행

    // ✅ Zustand의 최신 상태 즉시 가져오기
    const { password, passwordConfirm } = useSignFormStore.getState(); 
    
    if (state) {
      if (password !== passwordConfirm) {
        state(false); // ❌ 비밀번호 불일치
      } else {
        state(true); // ✅ 비밀번호 일치
      }
    };
  }

  return (
    <Wrapper>
    <Container
      type={type}
      placeholder={placeholder}
      defaultValue={defaultValue}
      onBlur={handleBlur}
      $isValid={isValid}
    />
    </Wrapper>
  );
};

export default InputBox;
